import React from 'react';
import PropTypes from 'prop-types';
import CTA from './global/CTA';

export default function HeroBanner({ data, state }) {
  if (!data) return null;
  const user = state?.cscAdminProfile?.data || {};
  const title = data.title;
  const subTitle = data.sub_title;
  const banner = data.banner || {};
  const mobile = banner.mobile || {};
  const tablet = banner.tablet || {};
  const desktop = banner.desktop || {};

  const primaryCta = data.click_to_action_primary || {};
  const secondaryCta = data.click_to_action_secondary || {};

  const primaryTitle = primaryCta.title;
  const primarySupplement = primaryCta.supplementary_text;
  const secondaryTitle = secondaryCta.title;
  const secondarySupplement = secondaryCta.supplementary_text;

  const key = data.content_type_uid || 'hero';
  const mobileUrl =
    (mobile && mobile.src) ||
    (tablet && tablet.src) ||
    (desktop && desktop.src) ||
    '';
  const tabletUrl =
    (tablet && tablet.src) ||
    (desktop && desktop.src) ||
    (mobile && mobile.src) ||
    '';
  const desktopUrl =
    (desktop && desktop.src) ||
    (tablet && tablet.src) ||
    (mobile && mobile.src) ||
    '';

  const css = `
.hero-section[data-hero-key="${key}"]{background-image:url(${mobileUrl});}
@media (min-width:768px){.hero-section[data-hero-key="${key}"]{background-image:url(${tabletUrl});}}
@media (min-width:1025px){.hero-section[data-hero-key="${key}"]{background-image:url(${desktopUrl});}}
`;

  return (
    <>
      <style>{css}</style>
      <section className='section-wrapper hero-section row' data-hero-key={key}>
        <div className='content'>
          {title && (
            <div className='hero-title'>
              <h5 className='title'>{title}</h5>
              {subTitle && <p className='line2'>{subTitle}</p>}
            </div>
          )}
          {
          user && user.isAgent ? <></> :
          <CTA
            cta={{
              type: primaryCta.type,
              title: primaryTitle,
              supplementary_text: primarySupplement,
              action: primaryCta.action,
              customBtnCss: `${user.isAgent ? "display-none " : ""}btn btn-gr`,
            }}
            variant='primary'
          />
          }
          <CTA
            cta={{
              type: secondaryCta.type,
              title: secondaryTitle,
              supplementary_text: secondarySupplement,
              action: secondaryCta.action,
            }}
            variant='secondary'
          />
        </div>
      </section>
    </>
  );
}

HeroBanner.propTypes = {
  data: PropTypes.shape({
    content_type_uid: PropTypes.string,
    title: PropTypes.string,
    sub_title: PropTypes.string,
    banner: PropTypes.shape({
      mobile: PropTypes.shape({
        src: PropTypes.string,
        content_type: PropTypes.string,
      }),
      tablet: PropTypes.shape({
        src: PropTypes.string,
        content_type: PropTypes.string,
      }),
      desktop: PropTypes.shape({
        src: PropTypes.string,
        content_type: PropTypes.string,
      }),
    }),
    click_to_action_primary: PropTypes.shape({
      type: PropTypes.string,
      title: PropTypes.string,
      supplementary_text: PropTypes.string,
      action: PropTypes.shape({ selector: PropTypes.string }),
    }),
    click_to_action_secondary: PropTypes.shape({
      type: PropTypes.string,
      title: PropTypes.string,
      supplementary_text: PropTypes.string,
      action: PropTypes.shape({
        link: PropTypes.shape({ href: PropTypes.string }),
        target: PropTypes.string,
      }),
    }),
  }),
};
